import React from "react";
import { ProjectSearchPageInitialState, PageNewState } from ".";

export const ProjectSearchPageContext = React.createContext({
  pageState: ProjectSearchPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
